import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Appointments'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Appointments',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/appointments',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
